import { axiosInstanceV2 } from "@src/shared/api";
import { IFiltersResponseDto } from "../interfaces/filtersResponseDto";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { REQUEST_HH_API_URL } from "../constants";

export const getFilters = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.get<IFiltersResponseDto>(
    REQUEST_HH_API_URL.getFilters(),
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};